<template>
  <el-dialog
    v-dialogDrag
    title="补考"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="small-dialog"
  >
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="150px">
      <el-row>
        <el-form-item :label="`${$t('补考时间')}`" prop="time">
          <el-date-picker
            v-model="formData.time"
            type="datetimerange"
            size="small"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="!w-440px"
          >
          </el-date-picker>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item :label="`${$t('补考人')}`" prop="student">
          <!-- <el-input
            size="small"
            disabled
            style="width:350px"
            type="textarea"
            v-model="formData.student"
            :rows="6"
          /> -->
          <div class="mb-20px flex search-box">
            <department-select
              class="mr-10px !w-230px depart-select"
              v-model="searchData.departmentId"
              placeholder="所属部门"
            ></department-select>
            <el-input
              size="small"
              class="mr-10px !w-130px"
              placeholder="姓名"
              v-model="searchData.name"
              clearable
            ></el-input>
            <el-button size="small" type="primary" @click="searchList">搜索</el-button>
          </div>
          <el-table
            :data="filterTableData"
            border
            height="300px"
            stripe
            class="w-440px"
            row-key="examinee"
            @selection-change="handleSelectionChange"
            v-loading="loading"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
              reserve-selection
            ></el-table-column>
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="department" label="部门" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="examineeName"
              label="姓名"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="score" label="分数" width="80"></el-table-column>
          </el-table>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button type="primary" size="small" @click="subData" :loading="saveLoading">{{
        $t('保存')
      }}</el-button>
      <el-button size="small" @click="dialogVisible = false">{{ $t('取消') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { TaskExamAnswerRecordApi, ExamPlanApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'
import { map } from 'lodash'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'

const taskExamAnswerRecordApi = new TaskExamAnswerRecordApi()
const examPlanApi = new ExamPlanApi()
export default {
  name: 'anew-action',
  components: {
    DepartmentSelect,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    operateData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      saveLoading: false,
      loading: false,
      searchData: {
        departmentId: '',
        name: '',
      },
      tableData: [],
      filterTableData: [],
      formData: {
        time: [],
        student: '',
      },
      formRules: {
        time: [{ required: true, validator: this.validatorDateArr, trigger: ['blur', 'change'] }],
        student: [
          { required: true, message: this.$t('无要补考的考生'), trigger: ['blur', 'change'] },
        ],
      },
      pickerOptions: {
        disabledDate(v) {
          return dayjs(v).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
        },
      },
      selection: [],
    }
  },
  mounted() {
    this.getStudent()
  },

  methods: {
    validatorDateArr(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error('请输入!'))
        return
      }
      if (dayjs(value[0]).valueOf() < dayjs().valueOf()) {
        callback(new Error('补考开始时间不能小于当前时间'))
      }
      const duration = dayjs(value[1]).diff(dayjs(value[0]), 'minute')
      if (duration < Number(this.operateData.sessionDuration)) {
        callback(new Error('补考考试时长不能小于场次考试时长'))
        return
      }
      callback()
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    searchList() {
      this.filterTableData = this.tableData.filter((item) => {
        const nameFilter = this.searchData.name
          ? item.examineeName && item.examineeName.includes(this.searchData.name)
          : true
        const departmentFilter = this.searchData.departmentId
          ? item.departmentId && item.departmentId.includes(this.searchData.departmentId)
          : true
        return nameFilter && departmentFilter
      })
    },
    async getStudent() {
      this.tableData = []
      this.selection = []
      this.loading = true
      const [err, res] = await taskExamAnswerRecordApi.makeUpExamExamineeNames({
        examSessionId: this.operateData.sessionId,
      })
      if (err) return
      this.formData.student = res.join('、')
      this.tableData = res
      this.searchList()
      this.$nextTick(() => {
        this.loading = false
      })
    },
    subData() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        if (dayjs(this.formData.time[0]).valueOf() < dayjs().valueOf()) {
          this.$message.warning('补考开始时间不能小于当前时间')
          return
        }
        if (this.selection.length === 0) {
          this.$message.warning('请勾选需要进行补考的考生')
          return
        }
        this.saveLoading = true
        const params = {
          examSessionId: this.operateData.sessionId,
          makeUpExamStartTime: this.formData.time[0],
          makeUpExamEndTime: this.formData.time[1],
          examineeIds: map(this.selection, 'examinee'),
        }
        const [err, res] = await examPlanApi.makeUpExam({ body: params })
        this.saveLoading = false
        if (err) return
        this.dialogVisible = false
        this.$emit('handleOk')
        this.$message.success('提交成功')
        this.$emit('success')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.depart-select {
  ::v-deep .el-input {
    width: 100%;
  }
}
</style>
